import api from "@/api";
import DataResponse from "@/types/DataResponse";
import InstallmentPlan from "@/types/InstallmentPlan";

/** The Installment plans the buyer can pay their waiting Order in with a card of this BIN. */
export default async function getInstallmentPlans(orderId: string, bin: string): Promise<InstallmentPlan[]> {
  const response = await api.get<DataResponse<InstallmentPlan[]>>("/api/checkout/installments", {
    params: { order: orderId, bin },
  });

  return response.data.data;
}
